module.exports = __webpack_public_path__ + "img/pic_coinstore_x4value@3x.031c3650.png";